import { withSerialization } from '@exodus/atoms'
import { createFusionAtom } from '@exodus/fusion-atoms'
import BJSON from 'buffer-json'

const createFiatAuthKeyPairAtom = ({ fusion }) => {
  const deserialize = (value) => (value ? BJSON.parse(value) : undefined)
  const serialize = (value) => BJSON.stringify(value)
  const atom = createFusionAtom({
    fusion,
    online: true,
    path: 'private.fiatAuthKeyPair',
  })

  return withSerialization({ atom, deserialize, serialize })
}

const fiatAuthKeyPairAtomDefinition = {
  id: 'fiatAuthKeyPairAtom',
  type: 'atom',
  factory: createFiatAuthKeyPairAtom,
  dependencies: ['fusion'],
  public: true,
}

export default fiatAuthKeyPairAtomDefinition
